import { render, staticRenderFns } from "./AgentOpenHome.vue?vue&type=template&id=2d2853fb&scoped=true"
import script from "./AgentOpenHome.vue?vue&type=script&lang=js"
export * from "./AgentOpenHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2853fb",
  null
  
)

export default component.exports